export const getActualSectionPaddingForSmallScreenCss = ({ css }) => {
    const hasContentPadding = !!css['so-global-region-logo-content'];
    const customStrippedLogoPaddingConfiguration = hasContentPadding
        ? `
    .html-email-logo-column-strip-layout > table > tbody > tr > td {
      padding-right: 0px!important;
      padding-left: 0px!important;
    }
  `
        : '';
    const customLinkPaddingConfiguration = `
    .section-link-image > table > tbody > tr > td {
      padding-bottom: 0px!important;
    }

    .section-link-text > table > tbody > tr > td {
      padding-top: 24px!important;
    }
  `;
    const configurations = customStrippedLogoPaddingConfiguration.concat(customLinkPaddingConfiguration);
    return configurations;
};
//# sourceMappingURL=get-section-padding-tweaks-for-small-screen-css.js.map